import React, { forwardRef, ReactNode } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Loading from '@this/template/components/loading';

export interface IPageProps {
	children: ReactNode;
	container?: boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fluid';
	className?: string;
	visible?: boolean;
	loading?: boolean;
}
const Page = forwardRef<HTMLDivElement, IPageProps>(
	({ children, className, container, visible, loading, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={classNames('page', className, {
					[`container${typeof container === 'string' ? `-${container}` : ''}`]: container,
				})}
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...props}>
				<Loading visible={loading} />
				{visible && children}
			</div>
		);
	},
);
Page.displayName = 'Page';
Page.propTypes = {
	children: PropTypes.node.isRequired,
	// @ts-ignore
	container: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.oneOf([null, 'sm', 'md', 'lg', 'xl', 'xxl', 'fluid']),
	]),
	className: PropTypes.string,
	visible: PropTypes.bool,
	loading: PropTypes.bool,
};
Page.defaultProps = {
	container: 'xxl',
	className: undefined,
	visible: true,
	loading: false,
};

export default Page;
